import React from 'react'
import LuxPlusPromoCardCarousel from './LuxPlusPromoCardCarousel'
import LuxPlusMemberLandingLayout from './LuxPlusMemberLandingLayout'
import { useLuxPlusPromoCards } from 'luxPlus/hooks/useLuxPlusPromos'

function LuxPlusLoggedInLandingPageContent() {
  const promos = useLuxPlusPromoCards()

  return (
    <LuxPlusMemberLandingLayout
      heroRight={promos.length > 0 ? <LuxPlusPromoCardCarousel promotions={promos} /> : undefined}
    />
  )
}

export default LuxPlusLoggedInLandingPageContent
